export const BREADCRUMB_BANNER_1_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Breadcrumb items",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_label: "Home",
    meta_url: "/",
    meta_priority: 1,
    meta_status: true,
  },

  BREADCRUMB_BANNER_FIELDS_CONFIG: [
    {
      fieldName: "breadcrumb_strip_background_color",
      label: "Breadcrumb strip background",
      value: "#F4F4F4",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#F4F4F4",
      required: false,
      defaultValue: "#F4F4F4",
    },
    {
      fieldName: "link_text_color",
      label: "Link crumb colour",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#666666",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "current_text_color",
      label: "Current page crumb colour",
      value: "#943126",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#943126",
      required: false,
      defaultValue: "#943126",
    },
    {
      fieldName: "separator_color",
      label: "Separator colour",
      value: "#737373",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#737373",
      required: false,
      defaultValue: "#737373",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Label",
      fieldName: "meta_label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Home, Blog listing, …",
    },
    {
      header: "URL",
      fieldName: "meta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty on last crumb (current page)",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Order (left to right)",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Visible",
      defaultValue: true,
    },
  ],
};
